import { routes } from 'constants/config';
import { webWidgetMappings } from 'selectors/pathBuilder';
import ContentMappingBase from './partials/ContentMappingBase';

export default ContentMappingBase({
  displayName: 'WebWidgetMappings',
  mappingsSelector: webWidgetMappings,
  header: 'Web Widget',
  headerTooltip:
    'Only learners who can see this content in the Learning Library will see it in the Web Widget.',
  UIStateKey: 'webWidget',
  contentMappingProps: {
    addButtonText: 'Add to Web Widget',
    removeTooltip: 'Remove Web Widget Mapping',
    viewMappingsText: 'View all mapped content and keywords',
    viewMappingsUrl: routes.WEB_WIDGETS,
    renderMapping: mapping => mapping.relatedUrl.name,
    suggestionsProps: {
      placeholder: 'Add a related keyword',
      url: routes.WEB_WIDGETS_FILTER,
      queryParam: 'name',
      mapResponseToSuggestions: response => response.matchedNames,
      getSuggestionValue: suggestion => suggestion.name,
      renderSuggestion: suggestion => suggestion.name,
    },
  },
});
